(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-charity-popup"] && !Shopify.designMode) return;
  try {
    const bbCharityDialog = document.getElementById('bb-charity-dialog');
if (bbCharityDialog) {
  let bbCharityOpener;
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-bb-charity-open]');
    if (opener && !bbCharityDialog.open) {
      bbCharityOpener = opener.closest('dialog') ? document.querySelector('[data-bb-menu-open]') : opener;
      bbCharityDialog.showModal();
    }
    if (event.target.closest('[data-bb-charity-close]')) bbCharityDialog.close();
  });
  bbCharityDialog.addEventListener('close', () => {
    if (bbCharityOpener?.isConnected) bbCharityOpener.focus();
  });
  bbCharityDialog.addEventListener('click', (event) => {
    if (event.target !== bbCharityDialog) return;
    const rect = bbCharityDialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) bbCharityDialog.close();
  });
}
  } catch(e) { console.error(e); }
})();

})();
